var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2992_2727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.281053 13.6647C0.227314 6.23717 6.20476 0.150772 13.6322 0.0970337C21.0597 0.0432952 27.1246 6.04257 27.1783 13.4701C27.2321 20.8975 21.2546 26.9839 13.8272 27.0377C6.39967 27.0914 0.334791 21.0921 0.281053 13.6647Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.281053 13.6647C0.227228 6.22521 6.20476 0.150772 13.6322 0.0970337C21.0597 0.0432952 27.1245 6.0306 27.1783 13.4701C27.2322 20.9095 21.2546 26.9839 13.8272 27.0377C6.39968 27.0914 0.334878 21.1041 0.281053 13.6647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2992_2727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6753 8.68579C19.1278 9.07862 18.5205 9.38043 17.877 9.5796C17.528 9.18347 17.066 8.90426 16.5534 8.77972C16.0407 8.65519 15.5023 8.69134 15.0109 8.8833C14.5195 9.07525 14.0988 9.41374 13.8057 9.85298C13.5126 10.2922 13.3613 10.811 13.3722 11.3392L13.3763 11.9149C12.3665 11.9484 11.3641 11.7313 10.4583 11.2829C9.55255 10.8344 8.77156 10.1686 8.18491 9.34461C8.18491 9.34461 5.92348 14.5421 11.1127 16.8073C9.93489 17.6206 8.52778 18.0344 7.09793 17.9878C12.2913 20.8286 18.5925 17.9046 18.5446 11.2846C18.5429 11.1242 18.5264 10.9644 18.4952 10.8071C19.0775 10.2235 19.4862 9.48892 19.6753 8.68579Z",
    fill: "#1DA1F2",
    stroke: "white",
    strokeWidth: 1.40286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2992_2727"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.281053 13.6647C0.227314 6.23717 6.20476 0.150772 13.6322 0.0970337C21.0597 0.0432952 27.1246 6.04257 27.1783 13.4701C27.2321 20.8975 21.2546 26.9839 13.8272 27.0377C6.39967 27.0914 0.334791 21.0921 0.281053 13.6647Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2992_2727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7938,
    height: 13.8161,
    fill: "white",
    transform: "translate(6.44141 7.05664) rotate(-0.414533)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitter);
export default __webpack_public_path__ + "static/media/ic_twitter.603ee730bd89c26185b0b21f5a6a2f38.svg";
export { ForwardRef as ReactComponent };